import { render } from "./VirtualKeyboardSvg.vue?vue&type=template&id=66b53891"
import script from "./VirtualKeyboardSvg.vue?vue&type=script&lang=js"
export * from "./VirtualKeyboardSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__